import { Collaborateur } from "../types/models/collaborateur";
import { Driver } from "../types/models/driver";

// Normalise un chauffeur (entreprise partenaire) à la même forme qu'un
// collaborateur (entreprise cliente), pour une sélection de demandeur unifiée.
// Les champs propres aux collaborateurs (ristourne, service minimal,
// isProfessionnel) n'ont pas d'équivalent chauffeur : valeurs par défaut.
export const driverToCollaborateur = (driver: Driver): Collaborateur => ({
  id: driver.id,
  idContact: driver.contact.id,
  entreprise: {
    id: driver.entreprise.id,
    nom: driver.entreprise.nom,
    factureAutorisee: driver.entreprise.factureAutorisee,
  },
  nom: driver.contact.nom,
  prenom: driver.contact.prenom,
  telephone: driver.contact.telephone,
  email: driver.contact.email,
  minimalService: null,
  ristourne: 0,
  isProfessionnel: false,
  isGestionnaire: false,
  // Un chauffeur n'est pas un collaborateur : c'est le volet métier de
  // l'entreprise partenaire, pas celui de l'entreprise cliente.
  isCollaborateur: false,
  isUtilisateur: driver.contact.isUtilisateur,
  isDisabled: driver.isDisabled,
  customData: driver.customData,
  entrepriseCustomDataSettings: driver.entrepriseCustomDataSettings,
});
